export const RetractableBannerDesignIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="4" />
        <path
            d="M17.8907 12.394V15.5312C17.8907 15.7911 17.6791 16.0018 17.418 16.0018H14.5819C14.4562 16.0018 14.3357 15.9519 14.247 15.8633C14.1583 15.7747 14.1087 15.6545 14.1092 15.5293V12.3921"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.1639 13.1781L16 10.8252L18.8362 13.1781"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.2395 8.94116H9.7605C9.55166 8.94116 9.38235 9.10971 9.38235 9.31763V17.9765C9.38235 18.1843 9.55166 18.3529 9.7605 18.3529H22.2395C22.4483 18.3529 22.6177 18.1843 22.6177 17.9765V9.31763C22.6177 9.10971 22.4483 8.94116 22.2395 8.94116Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.7459 18.3528V23.0587"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.2541 18.3528V23.0587"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
